import React, { useState } from 'react';
import { 
  Box, 
  Tabs, 
  Tab, 
  Paper, 
  Divider, 
  useTheme, 
  Chip 
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import ListAltIcon from '@mui/icons-material/ListAlt';
import CreateIcon from '@mui/icons-material/Create';
import BarChartIcon from '@mui/icons-material/BarChart';
import StorageIcon from '@mui/icons-material/Storage';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import ExploreIcon from '@mui/icons-material/Explore';
import RuleIcon from '@mui/icons-material/Rule';
import ArticleIcon from '@mui/icons-material/Article';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

/**
 * Navigation header/menu for RSOC pages
 * Provides consistent navigation between RSOC-related pages
 */
const RsocNavHeader = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine active tab based on current path
  const getActiveTab = () => {
    const path = location.pathname;
    // Hidden: generator, pages, parking-events, rules, articles, discovery
    if (path === '/rsoc/analytics') return 0;
    if (path === '/rsoc/launcher') return 1;
    if (path === '/rsoc/inspiration') return 2;
    return 0; // Default to analytics
  };
  
  const [value, setValue] = useState(getActiveTab());
  
  // Handle tab change
  const handleChange = (event, newValue) => {
    setValue(newValue);
    switch(newValue) {
      case 0:
        navigate('/rsoc/analytics');
        break;
      case 1:
        navigate('/rsoc/launcher');
        break;
      case 2:
        navigate('/rsoc/inspiration');
        break;
      default:
        navigate('/rsoc/analytics');
    }
  };
  
  return (
    <Paper 
      elevation={0} 
      sx={{ 
        mb: 2, 
        borderRadius: 1,
        border: `1px solid ${theme.palette.divider}`,
        overflow: 'hidden'
      }}
    >
      <Tabs 
        value={value} 
        onChange={handleChange}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
        aria-label="RSOC navigation tabs"
        sx={{ 
          minHeight: '48px',
          '& .MuiTab-root': { 
            minHeight: '48px',
            fontSize: '0.8rem',
            padding: '8px 12px'
          }
        }}
      >
        {/* Hidden tabs: Generator, Pages, Parking Events, Discovery, Rules, Articles */}
        {/* <Tab
          icon={<CreateIcon fontSize="small" />}
          label="Generator"
          iconPosition="start"
        />
        <Tab
          icon={<ListAltIcon fontSize="small" />}
          label="Pages"
          iconPosition="start"
        /> */}
        <Tab
          icon={<BarChartIcon fontSize="small" />}
          label="Analytics"
          iconPosition="start"
        />
        {/* <Tab
          icon={<StorageIcon fontSize="small" />}
          label="Parking Events"
          iconPosition="start"
        /> */}
        <Tab
          icon={<RocketLaunchIcon fontSize="small" />}
          label="Launcher"
          iconPosition="start"
        />
        {/* <Tab
          icon={<ExploreIcon fontSize="small" />}
          label="Discovery"
          iconPosition="start"
        />
        <Tab
          icon={<RuleIcon fontSize="small" />}
          label="Rules"
          iconPosition="start"
        />
        <Tab
          icon={<ArticleIcon fontSize="small" />}
          label="Articles"
          iconPosition="start"
        /> */}
        <Tab
          icon={<LightbulbIcon fontSize="small" />}
          label="Inspiration"
          iconPosition="start"
        />
      </Tabs>
      
     
    </Paper>
  );
};

export default RsocNavHeader; 